import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=19f65b1c"
import script from "./introduction.vue?vue&type=script&lang=ts"
export * from "./introduction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports